var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApprove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.346507L10.2981 2.24388L10.4033 2.39777L10.5621 2.30001L12.5197 1.09464L12.9338 3.35594L12.9674 3.53936L13.1522 3.51462L15.4308 3.20968L14.8893 5.44392L14.8454 5.62514L15.0243 5.67771L17.23 6.32592L15.8266 8.14677L15.7127 8.29446L15.8548 8.41526L17.6061 9.90454L15.5834 10.9972L15.4194 11.0858L15.5 11.2539L16.4941 13.3267L14.2019 13.5022L14.016 13.5164L14.0213 13.7028L14.0864 16.0008L11.921 15.2288L11.7454 15.1662L11.6744 15.3386L10.7992 17.4644L9.13498 15.8784L9 15.7497L8.86502 15.8784L7.20084 17.4644L6.32563 15.3386L6.25464 15.1662L6.079 15.2288L3.9136 16.0008L3.9787 13.7028L3.98398 13.5164L3.79806 13.5022L1.50585 13.3267L2.5 11.2539L2.58063 11.0858L2.41657 10.9972L0.393912 9.90454L2.1452 8.41526L2.28725 8.29446L2.17342 8.14677L0.770039 6.32592L2.97567 5.67771L3.15457 5.62514L3.11065 5.44392L2.5692 3.20968L4.8478 3.51462L5.03261 3.53936L5.0662 3.35594L5.48031 1.09464L7.43788 2.30001L7.59665 2.39777L7.70194 2.24388L9 0.346507Z",
    fill: "#7ED321",
    stroke: "#7ED321",
    strokeWidth: 0.391304
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.88201 12.5216L5.08698 9.51736L5.87517 8.67016L7.88201 10.8212L12.1249 6.26074L12.9131 7.11395L7.88201 12.5216Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprove);
export default __webpack_public_path__ + "static/media/approve.4e256f665c96171b6d60d6b5d582f5ed.svg";
export { ForwardRef as ReactComponent };